import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";

import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { VehicleCategoryEntity } from "./vehicle-category.entity";
import { VehicleCategoryController } from "./vehicle-category.controller";
import { VehicleCategoryService } from "./vehicle-category.service";


@Module({
    imports: [
        TypeOrmModule.forFeature([VehicleCategoryEntity]),
    ],
    controllers: [VehicleCategoryController],
    providers: [VehicleCategoryService, ApplicationExceptionHandler]
})
export class VehicleCategoryModule {

}